<template>
    <div class="viewBox">
       <div class="editor">
           <div class="left">
               <button @click="changePhoto(index)" :class="photoActiveIndex==index ? 'photoActive':''" v-for="(item,index) in photoList" :key="index">
                    <img :src="`https://respool.isheji.com/isheji/static/qiye/image/lab/elementDisassembly/${item}`" >
                   
               </button>
            </div>
            <div class="center">
                <div class="buttonList">
                   <div>
                        <button @click="changeButton(index)" :class="buttonActiveIndex==index ? 'buttonActive':''" v-for="(item,index) in buttonList" :key="index" v-html="item.html+item.name"></button>
                   </div>
                    <button @click="setCropper" :class="buttonActiveIndex==1 ? 'buttonActive':''">提交请求</button>
                </div>
                <div class="img">
                    <vueCropper
                        ref="cropper"
                        :img="`https://respool.isheji.com/isheji/static/qiye/image/lab/elementDisassembly/${photoToolList[photoActiveIndex]}`"
                        :outputSize="option.size"
                        :outputType="option.outputType"
                        :autoCropWidth="option.autoCropWidth"
                        :autoCropHeight="option.autoCropHeight"
                        :info="false"
                        :full="option.full"
                        :canScale="option.canScale" 
                        :canMove="false"
                        :canMoveBox="option.canMoveBox"
                        :original="option.original"
                        :autoCrop="option.autoCrop"
                        :fixed="option.fixed"
                        :fixedNumber="option.fixedNumber"
                        :centerBox="option.centerBox"
                        :infoTrue="option.infoTrue"
                        :fixedBox="option.fixedBox"
                    ></vueCropper>

                </div>
                   
            </div>
            <div class="right">
                <div class="header">
                    <span>素材拆分</span>
                </div>
                <div class="content" v-if="noRect && videoAuto[photoActiveIndex]">
                    <div class="item"  v-for="(item,index) in videoAuto[photoActiveIndex].elementDisassembly" :key="index">
                        <img class='img' :src="item" alt="">
                    </div>
                </div>
                <div class="content" v-if="!noRect">
                    <div class="item" >
                        <img class='img' :src="noRectImg" alt="">
                    </div>
                </div>
            </div>
           
       </div>
    </div>
</template>
<script>
import Axios from "axios";

export default {
   
    data(){
        return{
            photoList:[
                '1.jpg',
                '2.jpg',
                '3.jpg',
                '4.jpg',
            ],
            photoToolList:[
                '1.png',
                '2.png',
                '3.png',
                '4.png',
            ],
           option: {
                info: true, // 裁剪框的大小信息
                outputSize: 1, // 裁剪生成图片的质量
                outputType: 'png', // 裁剪生成图片的格式
                canScale: false, // 图片是否允许滚轮缩放
                autoCrop: false, // 是否默认生成截图框
                canMoveBox: true, // 截图框能否拖动
                autoCropWidth: 200, // 默认生成截图框宽度
                autoCropHeight: 200, // 默认生成截图框高度
                fixedBox: false, // 固定截图框大小 不允许改变
                fixed: false, // 是否开启截图框宽高固定比例
                fixedNumber: [1, 1], // 截图框的宽高比例
                full: false, // 是否输出原图比例的截图
                original: false, // 上传图片按照原始比例渲染
                centerBox: false, // 截图框是否被限制在图片里面
                infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
            },

            photoActiveIndex:0,
            videoAuto:[],
            buttonList:[
                    {
                        name:'增加选框',
                        html:'<svg width="18" height="18"><path d="M2.25 2.25v4.5H0V.337C0 .151.151 0 .338 0H6.75v2.25h-4.5zm0 9v4.5h4.5V18H.338A.338.338 0 010 17.662V11.25h2.25zM17.663 0c.186 0 .337.151.337.337V6.75h-2.25v-4.5h-4.5V0h6.413zM15.75 15.75v-4.5H18v6.412a.337.337 0 01-.337.338H11.25v-2.25h4.5zM13 10.125h-2.875V13h-2.25v-2.875H5v-2.25h2.875V5h2.25v2.875H13v2.25z" fill="#202437" fill-rule="evenodd"></path></svg>',
                    },
                    {
                        name:'清空选框',
                        html:'<svg width="18" height="18"><path d="M2.25 2.25v4.5H0V.337C0 .151.151 0 .338 0H6.75v2.25h-4.5zM17.663 0c.187 0 .337.151.337.337V6.75h-2.25v-4.5h-4.5V0h6.413zM2.25 11.25v4.5h4.5V18H.338A.338.338 0 010 17.662V11.25h2.25zm13.5 4.5v-4.5H18v6.412c0 .187-.15.338-.337.338H11.25v-2.25h4.5zM5 10.125v-2.25h8v2.25H5z" fill="#202437" fill-rule="evenodd"></path></svg>'
                    },
                ],
            noRect:true,
            noRectImg:'',
            noCropper:true,
            buttonActiveIndex:0,
            itemLabelCurrentIndex:0,
            itemFaceCurrentIndex:10000
            
           
        }
    },

    methods:{
        changePhoto(index){
            this.photoActiveIndex = index;
            this.noRect = true;
            this.noCropper = true;
            this.buttonActiveIndex = 0;
        },
        changeButton(index){
            if(index == 1){
                this.noCropper = true;
                this.buttonActiveIndex = 0;
                this.$refs.cropper.stopCrop()
                this.$refs.cropper.clearCrop()
            }
            else{
                 this.noCropper = false;
                 this.buttonActiveIndex = 1;
                 this.$refs.cropper.startCrop();
                 this.$refs.cropper.goAutoCrop();
            }
        },
        changetime(item){
           this.itemLabelCurrentIndex = parseInt(item.target.currentTime);
           let hasTime = false;
           this.videoAuto[this.photoActiveIndex].automaticFaceByLoad.forEach((element,index) => {
               if(element.time == parseInt(item.target.currentTime)){
                    hasTime = true
                   this.itemFaceCurrentIndex = parseInt(item.target.currentTime)
               }
           });
           if(!hasTime){
               this.itemFaceCurrentIndex = 10000
           }
        },
        setCropper(){
             this.$refs.cropper.getCropData((data)=>{
                 this.noRectImg = data;
                 this.noRect = false;
             })
        }
    },
    created() {
       Axios.get('json/elementDisassembly.json').then((res)=>{
            this.videoAuto = res.data;
       })
       if(this.$refs.cropper){
           this.$refs.cropper.stopCrop()
       }
       
    },
}
</script>
<style lang="scss" scoped>
      .editor{
        margin: auto;
        width:1280px;
        border-radius: 8px;
        overflow: hidden;
        background-color: #171a27;
        position: relative;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-pack: normal;
        justify-content: normal;
        -ms-flex-align: normal;
        align-items: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        -ms-flex-wrap: nowrap;
        flex-wrap: nowrap;
        margin-bottom: 16px;
        .left{
            width: 244px;
            position: relative;
            padding: 50px;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-pack: start;
            justify-content: flex-start;
            -ms-flex-align: center;
            align-items: center;
            -ms-flex-direction: column;
            flex-direction: column;
            -ms-flex-wrap: nowrap;
            flex-wrap: nowrap;
            button{
                width: 102px;
                height: 102px;
                border: none;
                padding: 0;
                overflow: hidden;
                position: relative;
                margin-top: 18px;
                &:first-child{
                    margin-top: 0;
                }
                cursor: pointer;
                img{
                    width: inherit;
                    height: inherit;
                    position: absolute;
                    top: 0;
                    left: 0;
                    -o-object-fit: cover;
                    object-fit: cover;
                    -o-object-position: center;
                    object-position: center;
                    -webkit-user-select: none;
                    -moz-user-select: none;
                    -ms-user-select: none;
                    user-select: none;
                }
                .target{
                    opacity: 1;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    -webkit-transform: translate(-50%, -50%);
                    -ms-transform: translate(-50%, -50%);
                    transform: translate(-50%, -50%);
                    width: 32px;
                    height: 24px;
                    border-radius: 4px;
                    background-color: #fff;
                    pointer-events: none;
                    -webkit-transition: opacity ease-in-out 280ms;
                    -o-transition: opacity ease-in-out 280ms;
                    transition: opacity ease-in-out 280ms;
                    display: -ms-flexbox;
                    display: flex;
                    -ms-flex-pack: center;
                    justify-content: center;
                    -ms-flex-align: center;
                    align-items: center;
                    -ms-flex-direction: row;
                    flex-direction: row;
                    -ms-flex-wrap: nowrap;
                    flex-wrap: nowrap;
                }
            }
            .photoActive{
                &::after{
                    content: '';
                    display: block;
                    position: absolute;
                    z-index: 2;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    border: 4px solid transparent;
                    -webkit-transition: border-color ease-in-out 280ms;
                    -o-transition: border-color ease-in-out 280ms;
                    transition: border-color ease-in-out 280ms;
                    border-color: #5986ff;
                }
            }
        }
        .center{
              -ms-flex: 1 1;
            flex: 1 1;
            padding: 24px 50px 50px;
            background-color: #202537;
            position: relative;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-pack: start;
            justify-content: flex-start;
            -ms-flex-align: center;
            align-items: center;
            -ms-flex-direction: column;
            flex-direction: column;
            -ms-flex-wrap: nowrap;
            flex-wrap: nowrap;
            img{
                position: relative;
                width: 100%;
                z-index: 1;
                height: 692px;
                overflow: hidden;
            }
            .rect{
                position: absolute;
                border: 4px solid #5986ff;
                z-index: 2;
            }
            .buttonList{
                margin-bottom: 24px;
                width: 100%;
                display: -ms-flexbox;
                display: flex;
                -ms-flex-pack: normal;
               justify-content: space-between;
                -ms-flex-align: center;
                align-items: center;
                -ms-flex-direction: row;
                flex-direction: row;
                -ms-flex-wrap: nowrap;
                flex-wrap: nowrap;
                button{
                    cursor: pointer;
                    padding: 12px 26px;
                    margin-right: 8px;
                    border-radius: 4px;
                    background-color: #515666;
                    font-size: 14px;
                    line-height: 20px;
                    color: #202437;
                    font-weight: 400;
                    outline: none;
                    border: none;
                    &:last-child{
                        margin-right: 0;
                    }
                }
                .buttonActive{
                    color: #fff;
                    background-color: #5986ff;
                }
            }
            .img{
                position: relative;
                width: 100%;
                z-index: 1;
                height: 692px;
                overflow: hidden;
                background-size: 20px 20px;
                background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2 2"><path d="M1 2V0h1v1H0v1z" fill-opacity=".2"/></svg>');
                background-color: #fff;
            }
        }
        .right{
            width: 244px;
            position: relative;
            .header{
                padding: 24px;
                color: #a0a3af;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
                border-bottom: 1px solid rgba(81,86,102,0.5);
                display: -ms-flexbox;
                display: flex;
                -ms-flex-pack: justify;
                justify-content: space-between;
                -ms-flex-align: center;
                align-items: center;
                -ms-flex-direction: row;
                flex-direction: row;
                -ms-flex-wrap: nowrap;
                flex-wrap: nowrap;
            }
            .content{
               position: relative;
                z-index: 1;
                padding: 8px 16px;
                max-height: 762px;
                min-height: 412px;
                overflow-y: auto;
                width: auto;
                     margin: 0;
                -webkit-overflow-scrolling: touch;
                .item{
                  display: inline-block;
                    position: relative;
                    padding: 8px;
                    width: 106px;
                    height: 106px;
                    -webkit-user-select: none;
                    -moz-user-select: none;
                    -ms-user-select: none;
                    user-select: none;
                    vertical-align: middle;
                    -webkit-transition: background-color ease-in-out 280ms;
                    -o-transition: background-color ease-in-out 280ms;
                    transition: background-color ease-in-out 280ms;
                    img{
                       position: absolute;
                        width: 74px;
                        height: 74px;
                        -o-object-position: center;
                        object-position: center;
                        -o-object-fit: contain;
                        object-fit: contain;
                        display: block;
                        top: 50%;
                        left: 50%;
                        -webkit-transform: translate(-50%, -50%);
                        -ms-transform: translate(-50%, -50%);
                        transform: translate(-50%, -50%);
                        z-index: 1;
                       
                    }
                     &::before{
                            content: '';
                            display: block;
                            position: absolute;
                            top: 8px;
                            right: 8px;
                            bottom: 8px;
                            left: 8px;
                            z-index: 0;
                            background-size: 20px 20px;
                            background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2 2"><path d="M1 2V0h1v1H0v1z" fill-opacity=".2"/></svg>');
                            background-color: #fff;
                        }
                   
                  
                }
                
            }
        }
    }
</style>
<style>
.target svg{
    width: 13px;
    height: 13px;
}
.target svg path{
    fill: #f84949;
}
.buttonList button svg{
    width: 20px;
    height: 20px;
    margin-right: 4px;
    vertical-align: middle;
}
.buttonList .buttonActive svg path{
    fill: #fff;
}
.play-pause-layer .btn-control{
    /* display: none; */
}
.cropper-modal{
    background: transparent !important;
}
.vue-cropper{
    position: absolute !important;
    top: 0;
    z-index: 20;
}

</style>